<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class="container-fluid">
    <h6  class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/admin/overview"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/aparment/index"> Apartment List </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" :to="'/aparment/view?id='+occupant.idCustomer"> {{ occupant.C_code}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update Occupants  </h6>
    <h6 class="custom-maintitle mb-2"><b>Update Occupants:{{ occupant.C_code }}</b></h6>
<div class="card ">
<div class="card-body">
  <form @submit.prevent="SaveCrm()" >







    <div class="row">
        <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label " style="font-size: small;">Number of Occupants</label>
            <input type="number" v-model="occupant.C_occupants" style="font-size: small;" class="form-control" required >
    </div>
  </div>
  

  
 
  
  

</div>






  
   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <button :disabled="isButtonDisabled" type="submit" class="mr-1 btn custom-btn btn-primary  mb-5 font-size_def">Update</button>
    </div>
    </div>



</form>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        'idcustomer':this.$route.query.id,

        occupant:{},
       
        isButtonDisabled: false
      
      


        
      }

    },
    mounted(){
 
      this.loadOccupant(this.idcustomer);
    },
methods : {

 

  async loadOccupant(id) {
    
    try {
      const { data} = await  axios.get('/mcustomer/loadoccupant?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.occupant = data.occupant;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async SaveCrm() {
  
    this.isButtonDisabled = true;
    
    try {
      const { data} = await  axios.post('/mcustomer/updateoccupant?id='+this.idcustomer,{userid:this.userid,occupant:this.occupant},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      this.status = data.status;
       if(this.status == 200){
        this.isButtonDisabled = false;
        this.$router.push('/aparment/view?id='+this.idcustomer);
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

      
    



  
 

  


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style scoped>

</style>